import { Component, EventEmitter, Input, OnInit, Optional, Output, inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { debounceTime } from 'rxjs';
import { PlainResultModalComponent } from '../../../../../../../shared/components/plain-result-modal/plain-result-modal.component';
import { StringHelper } from '../../../../../../../core/helpers/strings.helper';
import { TransferService } from '../../../../../../../core/services/transfer.service';
import { ModalOptionsConfig, ModalService } from '../../../../../nz-modal-service/modal.service';
import { DialogMessageType } from '../../../../../../../shared/models/utility.model';
import { BeneficiaryBankDetailsComponent } from '../../beneficiary-bank-details/beneficiary-bank-details.component';
import { CustomFormControl, CustomFormControlDefinition } from '../../../../../../../shared/utils/custom-form-control';

@Component({
	selector: 'app-add-beneficiary',
	templateUrl: './add-beneficiary.component.html',
	styleUrls: ['./add-beneficiary.component.scss']
})
export class AddBeneficiaryComponent implements OnInit {

	@Input() form: FormGroup;
	@Input() accountNoControl: CustomFormControlDefinition;
	@Input() accountNo: any;
	@Output() openBanksFormEmmiter = new EventEmitter();
	accountNumber: string;
	isMobile = false;
	ADD_BANK_ACCOUNT = 1;
	SELECT_BANK = 2;
	BENEFICIARY_DETAIL = 3;
	currentStep = this.ADD_BANK_ACCOUNT;
	configObj: any = {};
	runningModal: any;
	error: string;
	readonly nzModalData = inject(NZ_MODAL_DATA, { optional: true }) ?? {};

	constructor(private fb: FormBuilder, @Optional() public modalService: NzModalRef, public modal: ModalService,
		private transferService: TransferService) {
		if (this.modalService != null) {
			this.isMobile = false;
			this.setForm();
		} else {
			this.isMobile = true;
		}
	}

	setForm() {
		this.accountNoControl = new CustomFormControl()
			.id('account_no')
			.placeholder('Enter Account Number')
			.name('account_no')
			.minLength(10)
			.maxLength(10)
			.isAccountNumber()
			.isRequired()
			.build();

		this.form = this.fb.group({
			accountNo: this.accountNoControl.formGroupControl,
		});
	}

	ngOnInit(): void {
		if (this.modalService != null) {
			this.modalService.componentInstance = { ...this.modalService.componentInstance, ...this.nzModalData };
			this.configObj = this.modalService.componentInstance.data;
		}

		this.accountNoControl.formGroupControl.valueChanges.pipe(debounceTime(500)).subscribe(res => {
			if (res.length === 10 && res !== this.accountNumber) {
				if (this.isMobile) {
					this.openBanksFormEmmiter.emit();
				} else {
					this.modalService.destroy();
					this.openBanksForm(res);
				}

			}
			this.accountNumber = res;
		})
	}

	openBanksForm(accountNumber) {
		this.configObj.isMobile = false;
		this.configObj.addBeneficiary = true;
		this.configObj['desktopFlow'] = true;
		this.configObj.accountNumber = accountNumber;
		const config = this.createModalConfig(this.configObj);
		config.className = 'moniepoint-dialog';
		this.runningModal = this.modal.createModal(BeneficiaryBankDetailsComponent, config);
	}

	createModalConfig(data?) {
		const config = new ModalOptionsConfig();
		config.nzComponentParams.data = data;
		config.nzMaskClosable = true;
		config.nzComponentParams.callback = (result) => {
			this.savebeneficiary(result)
		};
		return config;
	}

	buildParams(beneficiaryDetails) {
		const params = {
			accountNumber: beneficiaryDetails?.accountNumber,
			bankCode: beneficiaryDetails?.bankCode,
			name: beneficiaryDetails?.account?.name
		}
		return params;
	}

	savebeneficiary(beneficiaryDetails) {
		this.transferService
			.addBeneficiary(this.buildParams(beneficiaryDetails))
			.then((res) => {
				const data: any = {};
				data.isMobile = this.isMobile;
				data.messageType = DialogMessageType.SUCCESS;
				data.modalBody = '';
				data.modalTitle = `Beneficiary Saved Successfully`;
				this.launchResultModal(data);
				this.transferService.goToManageBeneficiaryEvent();
			})
			.catch((error) => {
				this.error = StringHelper.getErrorMessageHttpErrorResponse(error);
				const data: any = {};
				data.isMobile = this.isMobile;
				data.messageType = DialogMessageType.FAILURE;
				data.modalBody = '';
				data.modalTitle = this.error;
				this.launchResultModal(data);
			});
	}

	launchResultModal(data) {
		const config = new ModalOptionsConfig();
		config.nzClosable = false;
		config.nzMaskClosable = false;
		config.nzCentered = false;
		config.nzComponentParams.data = data;
		config.nzComponentParams.callback = (result) => {
			this.runningModal.destroy();
		};
		this.runningModal = this.modal.createModal(PlainResultModalComponent, config);
	}

}
